import { createReducer, on } from "@ngrx/store";
import { findCostsPerEmployeeCatalogAct, loadCostsPerEmployeeCatalogByIdAct, resetCostsPerEmployeeCatalogAct, saveSuccessCostsPerEmployeeCatalogAct, setViolationsCostsPerEmployeeCatalogAct, showMsgErrorAct, updateSuccessCostsPerEmployeeCatalogAct } from "./cost-per-employee-catalog.action";
import { CostsPerEmployee } from "../../models/cost-per-employee";


const costsPerEmployee: CostsPerEmployee = new CostsPerEmployee();

export const CostsPerEmployeeCatalogReducer = createReducer (
    {
        costsPerEmployee,
        violations: {},
        loading: true 
    },
    on(resetCostsPerEmployeeCatalogAct, (state) => ({
        costsPerEmployee:  { ...costsPerEmployee },
        violations: {},
        loading: state.loading
    })),
    on(findCostsPerEmployeeCatalogAct, (state, { id }) =>({
        costsPerEmployee: { ...costsPerEmployee}, 
        violations: state.violations,
        loading: true
    })),
    on(loadCostsPerEmployeeCatalogByIdAct, (state, { costsPerEmployee }) =>({
        costsPerEmployee: { ...costsPerEmployee}, 
        violations: state.violations,
        loading: false
    })),
    on(saveSuccessCostsPerEmployeeCatalogAct, (state, { costsPerEmployeeNew }) => ({
        costsPerEmployee: { ...costsPerEmployeeNew },
        violations: {},
        loading: state.loading
    })),
    on(updateSuccessCostsPerEmployeeCatalogAct, (state, { costsPerEmployeeUpdated }) => ({
        costsPerEmployee: { ...costsPerEmployeeUpdated },
        violations: {},
        loading: state.loading
    })),
    on(setViolationsCostsPerEmployeeCatalogAct, (state, { costsPerEmployeeForm, violations }) => ({
        costsPerEmployee: { ...costsPerEmployeeForm },
        violations: {...violations},
        loading: false
    })),
    on(showMsgErrorAct, (state, { error }) => ({
        costsPerEmployee: state.costsPerEmployee,
        violations: {},
        loading: false
    }))
)